// extracted by mini-css-extract-plugin
module.exports = {"borderRadius":"VitrinsCards_borderRadius__re7BQ"};